import { Activity, memo } from 'react';

import useSpeakersForSession from '@/utils/speakers/use-speakers-for-session';
import { useAppSelector } from '@/store/hooks';
import { selectFirstSessionUuid } from '@/store/slices/project/selectors';
import useCastAndCrewLayoutType from '../../helpers/use-cast-and-crew-layout-type';
import CastCards from './cast-cards';
import CastList from './cast-list';
import Container from '@ui/container/container';

const CastContent = memo(() => {
  const sessionUuid = useAppSelector(selectFirstSessionUuid);
  const speakers = useSpeakersForSession({ sessionUuid });

  const { layout } = useCastAndCrewLayoutType();

  if (!speakers?.length || !sessionUuid) return null;
  return (
    <Container>
      <Activity mode={layout === 'grid' ? 'visible' : 'hidden'}>
        <CastCards speakers={speakers} sessionUuid={sessionUuid} />
      </Activity>

      <Activity mode={layout === 'list' ? 'visible' : 'hidden'}>
        <CastList speakers={speakers} sessionUuid={sessionUuid} />
      </Activity>
    </Container>
  );
});

CastContent.displayName = 'CastContent';

export default CastContent;
